module.exports = __webpack_public_path__ + "assets/images/correios_2.7b718de0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/correios_2.png
// module id = 387
// module chunks = 1